module.exports = __webpack_public_path__ + "static/ui-web-0076095fb4cd2b151c9a035d289c67e2.svg";